"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appConfigKeys = void 0;
var _logger = require("@ori/logger");
var _internals = require("./internals");
const appConfigKeys = exports.appConfigKeys = {
  PORT: {
    defaultValue: '8080'
  },
  HTTP_AUTH_USERNAME: {},
  HTTP_AUTH_PASSWORD: {},
  ENVIRONMENT: {
    parser: _internals.parseEnvironmentCode,
    isRequired: true
  },
  KEY_VAULT_NAME: {},
  KEY_VAULT_URL_TEMPLATE: {
    defaultValue: 'https://{keyVaultName}.vault.azure.net'
  },
  IDS_BE_CLIENT_ID: {
    kvSecretName: 'ids-be-client-id'
  },
  IDS_BE_CLIENT_SECRET: {
    kvSecretName: 'ids-be-client-secret'
  },
  IDS_FE_CLIENT_ID: {
    kvSecretName: 'ids-fe-client-id'
  },
  IDS_FE_CLIENT_SECRET: {
    kvSecretName: 'ids-fe-client-secret'
  },
  AZURE_TENANT_ID: {},
  AZURE_CLIENT_ID: {},
  AZURE_CLIENT_SECRET: {},
  IS_PR_BUILD: {
    defaultValue: false,
    parser: _internals.parseBoolean
  },
  IS_AKS: rawConfig => rawConfig.ServiceRuntime === 'K8s',
  LOG_PERFORMANCE: {
    defaultValue: false,
    parser: _internals.parseBoolean
  },
  USE_MYPAGES_DASHBOARD_PROXY: {
    defaultValue: true,
    parser: _internals.parseBoolean
  },
  PROXY_ENABLED: rawConfig => !!rawConfig.IS_PR_BUILD || rawConfig.ServiceRuntime !== 'K8s',
  TENANT: {},
  AI_SAMPLING_PERCENTAGE: {
    kvSecretName: 'APPINSIGHTS-SAMPLING-PERCENTAGE',
    defaultValue: 0,
    parser: _internals.parseNumber
  },
  ACTIVE_TENANTS: rawConfig => (0, _internals.parseActiveTenants)(rawConfig.ACTIVE_TENANTS),
  AI_RESOURCE_ID: {},
  APPLICATIONINSIGHTS_CONNECTION_STRING: {},
  LOGGER_CONFIG: rawConfig => {
    if (!rawConfig.LOGGER_CONFIG) {
      return undefined;
    }
    try {
      const parsedValue = _logger.loggerConfigurationSchema.parse(JSON.parse(String(rawConfig.LOGGER_CONFIG)));
      return parsedValue;
    } catch (error) {
      // eslint-disable-next-line no-console -- better to do this outside the ori logger
      console.warn(`\x1b[33mWarning\x1b[0m: Env variable LOGGER_CONFIG is not valid, because ${error}`);
      return undefined;
    }
  }
};
